export default __webpack_public_path__ + "static/The-Enterprise-Path-to-Service-Mesh-Architectures-e63c8326b587315a7f07b0086cf4ba3d.webp";